import React from 'react';

import { Checkbox as MuiCheckbox } from '@mui/material';

import Checked from './assets/checked.svg';
import Icon from './assets/icon.svg';
import Indeterminate from './assets/indeterminate.svg';

const Checkbox: typeof MuiCheckbox = (props) => (
    <MuiCheckbox
        icon={<Icon />}
        sx={{ padding: 0 }}
        checkedIcon={<Checked />}
        indeterminateIcon={<Indeterminate />}
        {...props}
    />
);

export default React.memo(Checkbox);
